import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { appQueryParameters } from '@clubmed/utils';
import { ICONS } from 'Components/utils/icon/icons';
import { LAYER_NAME_UPSELL_RENTALS } from 'Components/utils/layers/layers.constants';
import { useCurrentUri } from 'Src/hooks/use-current-uri/useCurrentUri';
import { useLayer } from 'Src/hooks/use-layer/useLayer';
import { t } from 'Src/i18n';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
import { Icon } from 'Components/frameworks/icon/Icon';
import { Image } from 'Components/frameworks/image/Image';
import { Title } from 'Components/frameworks/title/Title';
import { Text } from 'Components/frameworks/text/Text';
type Props = {
  className: string;
  layerName?: string;
  onClick: () => void;
  text?: string;
};
export const RentalsCta = ({ className, layerName, onClick, text }: Props) => {
  const currentUri = useCurrentUri();
  const newUri = currentUri
    .clone()
    .removeSearch(appQueryParameters.openLayer)
    .removeSearch('catId')
    .resource();
  const { nextUri } = useLayer(layerName || LAYER_NAME_UPSELL_RENTALS, {}, newUri);
  const title = t('common.rentals.title');
  const txt = text || t('common.rentals.text');
  const imageSrc = t('common.rentals.image');
  return (
    <DynamicLink
      onClick={onClick}
      className={classnames(
        'group relative isolate flex items-end justify-between overflow-hidden rounded-12 p-20 text-white',
        className,
      )}
      data-testid="UpsellRentals"
      shallow
      url={nextUri}
    >
      <div className="absolute inset-0 -z-1 flex transform items-center transition-all duration-250 ease-in group-hover:scale-105">
        <Image className="flex h-full w-full" imageUrl={imageSrc} />
        <div className="absolute bottom-0 h-1/2 w-full bg-gradient-to-t from-black/80" />
      </div>
      <div>
        <Title className="text-white" theme="title-brand-n0">
          {title}
        </Title>
        <Text className="text-white" text={txt} theme="text-sans-n3" />
      </div>
      <Icon className="shrink-0" hasRtl name={ICONS.ARROW_RIGHT} width="1rem" />
    </DynamicLink>
  );
};
